import "antd/es/tooltip/style";
import _Tooltip from "antd/es/tooltip";
import React from 'react';
import { useStore2 } from '../../hooks';
import { isCheckBoxType } from '../../utils';

var Description = function Description(_ref) {
  var displayType = _ref.displayType,
      schema = _ref.schema;
  var description = schema.description,
      descType = schema.descType;
  if (!description) return null;

  var _description = typeof description === 'string' && /(^<|\/>)/.test(description) ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }) : description;

  switch (displayType) {
    case 'row':
      return /*#__PURE__*/React.createElement(_Tooltip, {
        title: _description
      }, /*#__PURE__*/React.createElement("i", {
        className: "fr-tooltip-icon"
      }));

    case 'inline':
      return null;

    default:
      if (descType === 'icon') {
        return /*#__PURE__*/React.createElement(_Tooltip, {
          title: _description
        }, /*#__PURE__*/React.createElement("i", {
          className: "fr-tooltip-icon"
        }));
      }

      return /*#__PURE__*/React.createElement("span", {
        className: "fr-desc ml2"
      }, "( ".concat(description, " )"));
  }
};

var Title = function Title(_ref2) {
  var labelClass = _ref2.labelClass,
      labelStyle = _ref2.labelStyle,
      schema = _ref2.schema,
      displayType = _ref2.displayType,
      renderTitle = _ref2.renderTitle,
      globalRequiredMark = _ref2.requiredMark;

  var _useStore = useStore2(),
      globalDisplayType = _useStore.displayType,
      readOnly = _useStore.readOnly,
      colon = _useStore.colon;

  var title = schema.title,
      required = schema.required,
      type = schema.type,
      schemaRequiredMark = schema.requiredMark;
  var isObjType = type === 'object';

  var _displayType = schema.displayType || displayType || globalDisplayType || 'column';

  if (renderTitle) {
    return renderTitle({
      labelClass: labelClass,
      labelStyle: labelStyle,
      schema: schema,
      displayType: _displayType,
      readOnly: readOnly,
      colon: colon
    });
  }

  var requiredMark = typeof schemaRequiredMark === 'undefined' ? globalRequiredMark : schemaRequiredMark; // 左侧的的 * 号提示

  var TitleRequiredMark = null; // 左侧的 option 提示

  var TitleTextMark = null;

  if (required) {
    /**
     * ant-design requiredMark 实现
     * https://ant.design/components/form-cn/
     */
    if (requiredMark !== false && requiredMark !== 'optional') {
      TitleRequiredMark = /*#__PURE__*/React.createElement("span", {
        className: "fr-label-required"
      }, " *");
      TitleTextMark = null;
    }
  } else {
    if (requiredMark === 'optional') {
      TitleRequiredMark = null;
      TitleTextMark = /*#__PURE__*/React.createElement("span", {
        className: "fr-label-required-text"
      }, "\uFF08\u53EF\u9009\uFF09");
    }
  } // requiredMark 为 false 不展示必填符号


  if (requiredMark === false) {
    TitleRequiredMark = null;
    TitleTextMark = null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: labelClass,
    style: labelStyle
  }, title ? /*#__PURE__*/React.createElement("label", {
    className: "fr-label-title ".concat(isCheckBoxType(schema, readOnly) || _displayType === 'column' || !colon ? 'no-colon' : '') // checkbox不带冒号
    ,
    title: title
  }, TitleRequiredMark, /*#__PURE__*/React.createElement("span", {
    className: "".concat(isObjType ? 'b' : '', " ").concat(_displayType === 'column' ? 'flex-none' : '')
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  })), TitleTextMark, /*#__PURE__*/React.createElement(Description, {
    schema: schema,
    displayType: _displayType
  })) : null);
};

export default Title;